// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"get-started_bannerImage__NxGWu","zoomIn":"get-started_zoomIn__X6RlA"};